/**
 * Asset IQ product logo.
 *   variant="full"  -> icon + wordmark + tagline (default)
 *   variant="clean" -> icon + wordmark only (no tagline)
 */
const VARIANTS = {
  full:  { src: "/asset-iq-lockup.png", aspect: 1200 / 320 }, // 3.750 (with tagline)
  clean: { src: "/asset-iq-plain.png",  aspect: 848 / 320 },  // 2.650 (no tagline)
};

export default function AssetIQLogo({ className = "", height = 32, variant = "full" }) {
  const cfg = VARIANTS[variant] || VARIANTS.full;
  const width = Math.round(height * cfg.aspect);
  return (
    <img
      src={cfg.src}
      alt="Asset IQ"
      width={width}
      height={height}
      style={{ height: `${height}px`, width: `${width}px` }}
      className={`object-contain select-none pointer-events-none ${className}`}
      draggable={false}
      data-testid="asset-iq-logo"
    />
  );
}
